import { useRenderStore } from '../model/render-form.store';

export function useSeedManagement() {
  const seed = useRenderStore((state) => state.formData.seed);
  const setSeed = useRenderStore((state) => state.setSeed);
  const generateRandomSeed = useRenderStore(
    (state) => state.generateRandomSeed
  );
  const generateNextSeed = useRenderStore((state) => state.generateNextSeed);

  return {
    seed,
    currentSeed: seed,
    setSeed,
    generateRandomSeed,
    generateNextSeed,
  };
}
